import { Button, Row, Col, Upload, Typography, Flex,Input,Popover,Spin } from "antd";
import { ArrowRightOutlined,UploadOutlined } from "@ant-design/icons";
import { useState } from "react";
import { JiraGenieHeader } from "./jiraHeader";
import { JiraGeniewHomePage } from "./jiraHomepage";
import { ChatWindow } from "../chatwindow";
import { ChatModelFetch} from "../../../shared/axios";
import Lottie from "react-lottie";
import ResponseJson from "../../../assets/json/generating response animation.json";
import { v4 as uuid } from "uuid";
// import "./jiraGenie.css";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import remarkParse from "remark-parse";
import mermaid from "mermaid";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { oneDark } from "react-syntax-highlighter/dist/esm/styles/prism";
import { FaRegCopy } from "react-icons/fa";
import { toast } from "react-toastify";

const { Text } = Typography;

export const JiraGenieBot = () => {
  const [fileUploaded, setFileUploaded] = useState([]);
  const [inputFileUploaded, setinputFileUploaded] = useState([]);
  const [isChatting, setIsChatting] = useState(false);
  const [inputQuestion, setInputQuestion] = useState("");
  const [messages, setMessage] = useState([]);
  const [isTypingStopped, setIsTypingStopped] = useState(false);
  const [isMermaidRendering, setIsMermaidRendering] = useState(false);

  const uploadProps = {
    name: "file",
    fileList: fileUploaded,
    beforeUpload: (file) => {
      const allowedTypes = ["application/pdf", "application/msword", "application/vnd.openxmlformats-officedocument.wordprocessingml.document", "text/plain"];
      
      if (!allowedTypes.includes(file.type)) {
        toast.error("Only .doc, .docx, .txt, and .pdf files are allowed!", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        return false;
      }
      
      setFileUploaded([file]);
      toast.success("File Uploaded Successfully!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return false; // Prevent automatic upload
    },
    onRemove: () => {
      setFileUploaded([]);
    },
};

  const uploadInputProps = {
    name: "file",
    multiple: true, // Allow multiple files
    fileList: inputFileUploaded,
    beforeUpload: (file) => {
      const allowedTypes = ["application/pdf", "application/msword", "application/vnd.openxmlformats-officedocument.wordprocessingml.document", "text/plain"];
      
      if (!allowedTypes.includes(file.type)) {
        toast.error("Only .doc, .docx, .txt, and .pdf files are allowed!", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        return false; // Prevent upload
      }
      
      setinputFileUploaded((prevFiles) => [...prevFiles, file]); // Append new file
      toast.success("File Uploaded Successfully!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return false; // Prevent automatic upload
    },
    onRemove: (file) => {
      setinputFileUploaded((prevFiles) => prevFiles.filter((item) => item.uid !== file.uid));
    },
    showUploadList: { showRemoveIcon: true },
  };

  
  


  const handleCopy = (code) => {
    navigator.clipboard.writeText(code).then(
      () => {
        toast.success("Code copied to clipboard!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      },
      (err) => {
        toast.error("Failed to copy code. Please try again.", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      }
    );
  };
  

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: ResponseJson,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };  

  const handleTypingStopped = () => {
    setIsTypingStopped(true);
    // Set the bot response
    setMessage((pv) => {
      const newFields = [...pv];
      if (
        newFields.length !== 0 &&
        typeof newFields[newFields.length - 1]["content"] == "object"
      ) {
        newFields[newFields.length - 1] = {
          ...newFields[newFields.length - 1],
          content: "The Response Has Been Canceled By User.",
        };
      }

      return newFields;
    });
  };
  // Accpets the feedback and enables the input field
  const handleFeedback = (value, botID) => {
    const updatedData = messages.map((item) => {
      if (item?.bot_id === botID) {
        return {
          ...item,
          feedbackAccepted: [...item["feedbackAccepted"], value],
        }; // Only update matching item
      }
      return item;
    });
    setMessage(updatedData);
  };

  // Accpets the typing completed value
  const handleTypingCompleted = (value) => {
    setMessage((pv) => {
      const newFields = [...pv];

      if (
        newFields.length !== 0 &&
        newFields[newFields.length - 1]["typingCompleted"] == null
      ) {
        newFields[newFields.length - 1] = {
          ...newFields[newFields.length - 1],
          typingCompleted: value,
        };
      }
      return newFields;
    });
    setIsTypingStopped(false);
  };


  const handleQuestionSubmitted = async (question) => {
    const newUuid = uuid();

    if (!fileUploaded) {
      console.error("No file uploaded");
      return;
    } // Prevent submission if no file

    const formData = new FormData();
    formData.append("pdf_file", fileUploaded[0]);
    inputFileUploaded.forEach((file) => {
      formData.append("context_pdf_files", file); // Append each file separately
    });
    if (inputQuestion.trim() !== "") {
      formData.append("summarize_text", inputQuestion.trim());
    }

    setInputQuestion("");


    // Set the user question
    setMessage((pv) => [
      ...pv,
      {
        human_type: "user",
        content: (
          <>
            {inputQuestion.trim()}{" "}
            {fileUploaded.length > 0 && (
              <Text type="secondary">({fileUploaded[0].name})</Text>
            )}
          </>
        ),
      },
      {
        bot_id: newUuid,
        human_type: "bot",
        content: (
          <Row>
            <span className="chat-gr-text">Generating response</span>
            <Lottie options={defaultOptions} height={20} width={40} />
          </Row>
        ),
        typingCompleted: null,
      },
    ]);
    
    setIsChatting(true);
    
    // const response = await ChatModelFetch.submit_question({ question: question },{});
    let hasClearedContent = false;
    const { result } = await ChatModelFetch.brd_upload(formData, (chunk) => {
      setMessage((prevMessages) => {
        const newMessages = [...prevMessages];
    
        // Find the last bot message
        const lastIndex = newMessages.length - 1;
        if (
          lastIndex >= 0 &&
          newMessages[lastIndex]["bot_id"] === newUuid
        ) {
          let previousContent = hasClearedContent
            ? (typeof newMessages[lastIndex].content === "object"
                ? newMessages[lastIndex].content.props.children || []
                : [newMessages[lastIndex].content])
            : [];
    
          hasClearedContent = true;
    
          // Concatenate new chunk correctly
          const updatedContent = [...previousContent, chunk].join("");

          const mermaidMatch = updatedContent.match(/```mermaid([\s\S]*?)```/);
          if (mermaidMatch) {
            setIsMermaidRendering(true); // Show loader while rendering

            setTimeout(() => {
              mermaid.contentLoaded();
              setIsMermaidRendering(false); // Hide loader once rendered
            }, 1000);
          }
    
          newMessages[lastIndex] = {
            ...newMessages[lastIndex],
            content: (
              <ReactMarkdown
                remarkPlugins={[remarkParse, remarkGfm]}
                components={{
                  code({ node, inline, className, children, ...props }) {
                    const match = /language-(\w+)/.exec(className || "");
                    const codeString = String(children).replace(/\n$/, "");

                    if (!inline && match?.[1] === "mermaid") {
                      return isMermaidRendering ? (
                        <div className="mermaid-loader">
                          <Spin size="small" /> Rendering diagram...
                        </div>
                      ) : (
                        <div className="mermaid">{codeString}</div>
                      );
                    }

                    return !inline && match ? (
                      <div style={{ position: "relative", marginBottom: "1rem" }}>
                        <SyntaxHighlighter style={oneDark} language={match[1]} PreTag="div" {...props}>
                          {codeString}
                        </SyntaxHighlighter>
                        <button
                          onClick={() => handleCopy(codeString)}
                          style={{
                            position: "absolute",
                            top: "8px",
                            right: "8px",
                            background: "none",
                            border: "none",
                            cursor: "pointer",
                            color: "white",
                          }}
                          title="Copy to clipboard"
                        >
                          <FaRegCopy size={16} />
                        </button>
                      </div>
                    ) : (
                      <code className={className} {...props}>
                        {children}
                      </code>
                    );
                  },
                }}
              >
                {updatedContent}
              </ReactMarkdown>

            ),
          };
        }
        return newMessages;
      });
    });
    
    // Optionally, set typingCompleted to true once done
    setMessage((pv) => {
      const newFields = [...pv];
      if (
        newFields.length !== 0 &&
        newFields[newFields.length - 1]["bot_id"] === newUuid && 
        (typeof newFields[newFields.length - 1]["content"] == "object" ||
        (typeof newFields[newFields.length - 1]["content"] == "string" &&
          newFields[newFields.length - 1]["content"] !== "" &&
          newFields[newFields.length - 1]["typingCompleted"] === false))
        ){
        newFields[newFields.length - 1] = {
          ...newFields[newFields.length - 1],
          typingCompleted: true, 
          // content : result,
          responseID: "1", // Add responseID after the stream ends,
          feedbackAccepted: [],
        };
      }
  
      return newFields;
    });
  };

  const handleClearAll = async () => {
    setIsChatting(false);
    setInputQuestion("");
    setMessage([]);
    setIsTypingStopped(false);
  };


  return (
    <Row className="background-container">
      <JiraGenieHeader handleClearAll={handleClearAll} />
      {!isChatting ? (
        <JiraGeniewHomePage handleQuestionSubmitted={handleQuestionSubmitted}  />
        ) :( 
        <ChatWindow 
          chat_messages={messages}
          typingStopped={isTypingStopped}
          handleFeedback={handleFeedback}
          handleTypingCompleted={handleTypingCompleted}
          />
          )}

        <Row className="chat-input-section" align="bottom" justify={"center"} >
          <Col>
          
          <Row className="box">
            <Flex
              align="center"
              gap="small"
              className="box"
              style={{
                width: "100%",
                flexWrap: "wrap", // Allow wrapping on small screens
              }}
            >
              {/* Upload button */}
              <Upload {...uploadProps} style={{ flexShrink: 0 }}>
                <Button className="input-file-box">
                  Upload File
                </Button>
              </Upload>

              {/* Input field */}
              <Input
                className="input-chat-box"
                placeholder="Provide any additional context that is relevant to you (Optional)..."
                style={{ flex: 1, minWidth: "150px" }}
                onKeyDown={(ev) => {
                  if (ev.key === "Enter") {
                    ev.preventDefault();
                    handleQuestionSubmitted();
                  }
                }}
                suffix={
                  <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                    <Popover content="Upload Relevant Documents" placement="bottom">
                      <Upload {...uploadInputProps}>
                        <Button icon={<UploadOutlined />} />
                      </Upload>
                    </Popover>
                    <Button
                      disabled={
                        (fileUploaded.length === 0 && inputQuestion.trim() === "") ||
                        (messages.length > 0 && !messages[messages.length - 1].typingCompleted)
                      }
                      className="chat-submit-button"
                      onClick={() => {
                        if (fileUploaded.length > 0) {
                          // Handle file upload logic here
                          handleQuestionSubmitted(inputQuestion);
                        } else if (inputQuestion.trim()) {
                          // Handle message submission logic here
                          handleQuestionSubmitted(inputQuestion);
                        }
                      }}
                    >
                      {fileUploaded.length > 0 ? (
                        <UploadOutlined className="upload-icon" />
                      ) : (
                        <ArrowRightOutlined className="chat-arrow-icon" />
                      )}
                    </Button>

                  </div>
                }
                value={inputQuestion}
                onChange={(e) => setInputQuestion(e.target.value)}
              />

            </Flex>
          </Row>

          <Row className="chat-input-lower-div">
            <Text className="chat-input-beta-text">
              JiraGenie is in Beta version.
            </Text>
            <Button
              disabled={!isChatting}
              type="link"
              className="chat-input-clear-all"
              onClick={handleClearAll}
            >
              Clear All
            </Button>
          </Row>
        </Col>
      </Row>
      </Row>
  );
};
